import "../../Components/Widgets/TwoUpPromo/TwoUpPromo.scss";

const ROTATE_INTERVAL_MS = 5000;

function getContentSlideMaxHeight(container) {
    const stack = container.closest(".two-up-promo__stack");
    const content = container.closest(".two-up-promo__content");
    if (!stack || !content) {
        return null;
    }

    const heading = stack.querySelector(".two-up-promo__heading");
    const ctas = stack.querySelector(".two-up-promo__ctas");
    let usedHeight = 0;

    [heading, ctas].forEach((element) => {
        if (element) {
            usedHeight += element.getBoundingClientRect().height;
        }
    });

    const stackStyles = window.getComputedStyle(stack);
    const rowGap = parseFloat(stackStyles.rowGap || stackStyles.gap || "0") || 0;
    const rowCount = [heading, container, ctas].filter(Boolean).length;
    const totalGap = rowGap * Math.max(rowCount - 1, 0);
    const availableHeight = content.clientHeight
        - (parseFloat(window.getComputedStyle(content).paddingTop) || 0)
        - (parseFloat(window.getComputedStyle(content).paddingBottom) || 0);

    return Math.max(availableHeight - usedHeight - totalGap, 0);
}

function syncContentSlideArea(container) {
    const slides = container.querySelectorAll(".two-up-promo__content-slide");
    const activeSlide = container.querySelector(".two-up-promo__content-slide.is-active") || slides[0];
    const activeParagraph = activeSlide?.querySelector(".two-up-promo__paragraph");

    if (!activeSlide || !activeParagraph) {
        return;
    }

    const maxHeight = getContentSlideMaxHeight(container);
    container.style.removeProperty("min-height");
    activeParagraph.style.removeProperty("max-height");
    activeParagraph.classList.remove("is-clamped");

    if (maxHeight === null) {
        return;
    }

    let tallestSlideHeight = 0;
    slides.forEach((slide) => {
        tallestSlideHeight = Math.max(tallestSlideHeight, slide.scrollHeight);
    });

    const slideHeight = Math.min(Math.max(activeSlide.scrollHeight, tallestSlideHeight), maxHeight || tallestSlideHeight);
    container.style.minHeight = `${slideHeight}px`;

    const subhead = activeSlide.querySelector(".two-up-promo__subhead");
    const subheadHeight = subhead ? subhead.getBoundingClientRect().height : 0;
    const slideGap = parseFloat(window.getComputedStyle(activeSlide).gap || "0") || 0;
    const paragraphMaxHeight = Math.max(slideHeight - subheadHeight - (subhead ? slideGap : 0), 0);

    if (activeParagraph.scrollHeight > paragraphMaxHeight && paragraphMaxHeight > 0 && maxHeight > 0 && tallestSlideHeight > maxHeight) {
        activeParagraph.classList.add("is-clamped");
        activeParagraph.style.maxHeight = `${paragraphMaxHeight}px`;
    }
}

function setActiveContentSlide(container, slides, nextIndex) {
    slides.forEach((slide) => {
        slide.classList.remove("is-active");
        const paragraph = slide.querySelector(".two-up-promo__paragraph");
        if (paragraph) {
            paragraph.style.removeProperty("max-height");
            paragraph.classList.remove("is-clamped");
        }
    });

    slides[nextIndex].classList.add("is-active");
    syncContentSlideArea(container);
}

function setActiveSlide(slides, nextIndex) {
    slides.forEach((slide) => {
        slide.classList.remove("is-active");
    });

    slides[nextIndex].classList.add("is-active");
}

function initRotatingItems(container, itemSelector, setActiveItem) {
    const items = container.querySelectorAll(itemSelector);
    if (items.length <= 1) {
        return;
    }

    let activeIndex = 0;

    window.setInterval(() => {
        activeIndex = (activeIndex + 1) % items.length;
        setActiveItem(container, items, activeIndex);
    }, ROTATE_INTERVAL_MS);
}

(() => {
    const containers = document.querySelectorAll(".two-up-promo__content-slides");

    containers.forEach((container) => {
        const slides = container.querySelectorAll(".two-up-promo__content-slide");
        if (slides.length === 0) {
            return;
        }

        syncContentSlideArea(container);

        initRotatingItems(container, ".two-up-promo__content-slide", setActiveContentSlide);
    });

    document.querySelectorAll(".two-up-promo__slides--rotate").forEach((container) => {
        initRotatingItems(container, ".two-up-promo__slide", (slideContainer, slides, nextIndex) => {
            setActiveSlide(slides, nextIndex);
        });
    });

    window.addEventListener("resize", () => {
        document.querySelectorAll(".two-up-promo__content-slides").forEach((container) => {
            syncContentSlideArea(container);
        });
    });
})();
